import { AxiosClient } from '@pole/client/agromarket'
import { CanceledError } from 'axios'
import { reduxStore } from '@/api/client/base'
import { getJwt } from '@/logic/auth/reducer'

const baseURL = '/api/ms-core-templates-backend'

export const registerLibCoreTemplatesApiAxiosClient = () => {
  AxiosClient.registerApi('lib-core-templates-api', { baseURL, timeout: Number(process.env.API_RESPONSE_TIMEOUT) || 60_000 })
}

export const libCoreTemplatesApiAxiosClient = AxiosClient.getClient({
  apiName: 'lib-core-templates-api',
  onRequest: config => {
    if (!reduxStore.store) return config

    const reduxToken = getJwt()(reduxStore.store?.getState?.())
    if (!config.headers.Authorization && !!reduxToken?.length) config.headers.Authorization = `Bearer ${reduxToken}`

    return config
  },
})

export * from './types'
export { CanceledError }
export default libCoreTemplatesApiAxiosClient
